import { AudioMentionNew } from "@/types/MentionCard";
import { Button } from "@components/ui/button";
import { Trans } from "@lingui/react/macro";
import { SkipBackIcon } from "lucide-react";
import {
  useMediaDispatch,
  useMediaSelector,
  MediaActionTypes,
} from "media-chrome/react/media-store";

export default function PreviousMentionButton({
  mentions,
  disabled,
}: {
  disabled: boolean;
  mentions: AudioMentionNew[];
}) {
  const dispatch = useMediaDispatch();
  const mediaCurrentTime =
    useMediaSelector((state) => state.mediaCurrentTime) ?? 0;

  return (
    <Button
      disabled={disabled}
      size="icon-sm"
      variant="ghost"
      className="rounded-full"
      onClick={() => {
        const previousMention = mentions
          .filter(
            (m) => (m.indices_metadata?.start_time ?? 0) < mediaCurrentTime - 1
          )
          .at(-1);

        if (previousMention) {
          const type = MediaActionTypes.MEDIA_SEEK_REQUEST;
          const detail = previousMention.indices_metadata?.start_time ?? 0;
          dispatch({ type, detail });
        }
      }}
    >
      <SkipBackIcon className="fill-primary" />
      <span className="sr-only">
        <Trans>Föregående omnämnande</Trans>
      </span>
    </Button>
  );
}
